import React, { useEffect } from 'react';
import { MultiplayerLogo } from '../../../../components/icons';
import { PageLayout, Text } from '../../../../components';
import { useNavigate } from 'react-router-dom';
import { extractFromQuery } from '@repo-sapiens/helpers';
import { css } from '@emotion/css';
import { E_Route } from '@repo-sapiens/constants';
import { Container } from './styles';
type Params = {
  error?: 'access_denied' | 'invalid_request';
};

export const AuthFailedScreen = React.memo(() => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = React.useState<string>('');

  useEffect(() => {
    const { error } = extractFromQuery<Params>(window.location.search);

    switch (error) {
      case 'access_denied':
        setErrorMessage('You must allow access to continue.');
        break;
      case 'invalid_request':
        setErrorMessage('Invalid request. Please try again.');
        break;
      default:
        setErrorMessage('An unknown error occurred during authentication.');
    }

    setTimeout(() => {
      // closed this tab or window
      if (window.opener) {
        window.close();
      } else {
        // navigate to home
        navigate(E_Route.Home);
      }
    }, 3000);
  }, [navigate]);

  return (
    <PageLayout title="Setup | Multiplayer">
      <Container>
        <MultiplayerLogo
          style={{ height: '40px', marginBottom: '80px', marginTop: '-30px' }}
        />
        <Text.Body
          style={{ marginTop: '32px' }}
          className={css`
            @media (max-width: 1030px) {
              font-size: 30px !important;
            }
          `}
        >
          {errorMessage}
        </Text.Body>
        <div
          className={css`
            position: absolute;
            top: -10px;
            z-index: 0;
          `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1283"
            height="421"
            viewBox="0 0 1283 821"
            fill="none"
          >
            <g filter="url(#filter0_f_6159_5381)">
              <path
                d="M980 517.648H303.5L521.433 -852H802.93L980 517.648Z"
                fill="#313131"
                fillOpacity="0.45"
              />
            </g>
            <defs>
              <filter
                id="filter0_f_6159_5381"
                x="0.81543"
                y="-1154.68"
                width="1281.87"
                height="1975.02"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="151.342"
                  result="effect1_foregroundBlur_6159_5381"
                />
              </filter>
            </defs>
          </svg>
        </div>
      </Container>
    </PageLayout>
  );
});
